import { apiClient } from '../axios-instance';

export interface RadiusPricingBand {
  id: number;
  min_range_km: number;
  max_range_km: number | null;
  price: number;
  currency: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export const radiusPricingService = {
  getBands: async () => {
    const response = await apiClient.get<{ success: boolean; data: RadiusPricingBand[] }>('/admin/radius-pricing');
    return response.data;
  },

  createBand: async (data: Omit<RadiusPricingBand, 'id'>) => {
    const response = await apiClient.post<{ success: boolean; data: RadiusPricingBand; message: string }>('/admin/radius-pricing', data);
    return response.data;
  },

  updateBand: async (id: number, data: Partial<RadiusPricingBand>) => {
    const response = await apiClient.put<{ success: boolean; data: RadiusPricingBand; message: string }>(`/admin/radius-pricing/${id}`, data);
    return response.data;
  },

  deleteBand: async (id: number) => {
    const response = await apiClient.delete<{ success: boolean; message: string }>(`/admin/radius-pricing/${id}`);
    return response.data;
  },
};
